export const octoberUppercase = "sGMIUe";
export default {octoberUppercase};